/* lm-clarity-events.js – CRO-60 (2026-10-16): moved unchanged from snippets/lm-clarity-events.liquid (was an inline <script> on every page). */
  (() => {
    if (window.lmClarityEvents) return;
    const PAGE_TYPE = (document.currentScript && document.currentScript.dataset.pageType) || '';
    window.lmClarityEvents = true;
    const send = (name) => {
      try {
        if (typeof window.clarity === 'function') window.clarity('event', name);
      } catch (error) {}
    };
    const isAdd = (input) => {
      try {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        return /\/cart\/add(\.js)?(\?|$)/.test(new URL(url, location.href).pathname + '?');
      } catch (error) {
        return false;
      }
    };
    const originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function (input, init) {
        const promise = originalFetch.apply(this, arguments);
        const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (method === 'POST' && isAdd(input)) {
          promise.then((response) => {
            if (!response || !response.ok) return;
            send('add_to_cart');
            /* DEV-547: this add came from Buy now, which goes straight on to checkout */
            if (Date.now() - buyNowAt < 10000) { buyNowAt = 0; checkout(); }
          }, () => {});
        }
        return promise;
      };
    }
    document.addEventListener('dialog:after-show', (event) => {
      const target = event.target;
      if (target && (target.id === 'cart-drawer' || target.localName === 'cart-drawer')) send('drawer_cart_open');
    });
    let checkoutSent = 0;
    const checkout = () => {
      if (Date.now() - checkoutSent < 2000) return;
      checkoutSent = Date.now();
      send('begin_checkout');
    };
    document.addEventListener('submit', (event) => {
      const form = event.target;
      const submitter = event.submitter;
      if ((submitter && submitter.name === 'checkout') || (form && /\/checkout/.test(form.getAttribute('action') || ''))) checkout();
    }, true);
    document.addEventListener('click', (event) => {
      const link = event.target.closest && event.target.closest('a[href*="/checkout"]');
      if (link) checkout();
    }, true);
    /* DEV-547 (2026-09-29): Clarity's own smart event "Checkout" (09-29: 25) also counts taps on "Buy now" / "Pirkti dabar",
       most of them without a size, when only the size prompt shows (AddToCart 9, no session reached checkout). So that a tap
       and a real start of checkout can be told apart in Clarity:
         buy_now_tap       every tap on Buy now
         buy_now_no_size   that tap had no size chosen (the size prompt showed, nothing went into the cart)
       and a Buy now whose /cart/add succeeded (the browser then goes to checkout) also sends begin_checkout, like the drawer's
       Checkout button. Count real checkouts by begin_checkout, not by the smart event. */
    let buyNowAt = 0;
    const sizeMissing = (form) => {
      const vp = form && document.querySelector('variant-picker[form-id="' + form.getAttribute('id') + '"]');
      const pos = vp && vp.getAttribute('data-size-position');
      if (!pos || pos === '0') return false;
      return !!vp.querySelector('input[data-option-position="' + pos + '"]') && !vp.querySelector('input[data-option-position="' + pos + '"]:checked');
    };
    document.addEventListener('click', (event) => {
      const button = event.target.closest && event.target.closest('[data-lm-buy-now]');
      if (!button || button.disabled) return;
      send('buy_now_tap');
      if (sizeMissing(button.closest('form'))) { buyNowAt = 0; send('buy_now_no_size'); }
      else buyNowAt = Date.now();
    }, true);
    const slug = (url) => {
      try {
        const m = new URL(url, location.href).pathname.match(/\/collections\/([^/?#]+)/);
        return m ? m[1].toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 40) : '';
      } catch (error) {
        return '';
      }
    };
    document.addEventListener('click', (event) => {
      const a = event.target.closest && event.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href') || '';
      let name = '';
      const shelf = a.closest('[data-d291-shelf]');
      if (shelf) {
        const id = slug(shelf.getAttribute('data-url') || '');
        if (!id) return;
        if (/\/products\//.test(href)) name = 'home_shelf_' + id;
        else if (a.matches('.d291-sh__all, .d291-sh__more')) name = 'home_shelf_' + id + '_all';
      } else if (a.matches('.d291-cat__tile')) name = 'home_tile_' + slug(href);
      else if (a.matches('.d291-oc__card')) name = 'home_occasion_' + slug(href);
      else if (a.closest('[id$="__dev291_for_you"]') && /\/products\//.test(href)) name = 'home_for_you';
      else if (a.closest('[id$="__image_with_text_overlay_9UCppD"]')) name = 'home_hero';
      if (!name || /_$/.test(name)) return;
      send(name);
      try {
        if (typeof window.clarity === 'function') window.clarity('set', 'home_src', name);
      } catch (error) {}
    }, true);
    /* DEV-539: in-app browser, landing page type and product page steps */
    const whenClarity = (fn, tries) => {
      if (typeof window.clarity === 'function') { try { fn(); } catch (error) {} return; }
      if ((tries || 0) < 20) setTimeout(() => whenClarity(fn, (tries || 0) + 1), 500);
    };
    const ua = navigator.userAgent || '';
    const inApp = /Instagram/i.test(ua) ? 'instagram' : /FBAN|FBAV|FB_IAB|FBIOS|FB4A/i.test(ua) ? 'facebook' : /musical_ly|Bytedance|TikTok/i.test(ua) ? 'tiktok' : 'none';
    let landing = '';
    try {
      landing = sessionStorage.getItem('lm_d539_landing') || '';
      if (!landing) { landing = PAGE_TYPE; sessionStorage.setItem('lm_d539_landing', landing); }
    } catch (error) { landing = PAGE_TYPE; }
    whenClarity(() => { window.clarity('set', 'in_app', inApp); window.clarity('set', 'landing', landing); });
    /* the snippet is printed before the main section (header / drawer), so the product page part waits for the HTML */
    const pdp = () => {
      const main = document.querySelector('.shopify-section--main-product');
      if (!main) return;
      const done = {};
      const once = (name) => { if (done[name]) return; done[name] = true; whenClarity(() => window.clarity('event', name)); };
      const SIZE = /^(XXS|XS|S|M|L|XL|XXL|XXXL|[2-6]XL|\d{2}(\/\d{2})?|one size|vienas dydis)$/i;
      main.addEventListener('change', (event) => {
        const input = event.target;
        if (!input || !input.matches || !input.matches('variant-picker input[type="radio"][name*="-option"]')) return;
        const label = main.querySelector('label[for="' + input.id + '"]');
        const text = ((label && label.innerText) || input.value || '').trim();
        once(SIZE.test(text) ? 'pdp_size_pick' : 'pdp_colour_pick');
      }, true);
      main.addEventListener('click', (event) => {
        if (event.target.closest && event.target.closest('[aria-controls^="size-chart"]')) once('pdp_size_guide');
      }, true);
      document.addEventListener('click', (event) => {
        if (event.target.closest && event.target.closest('product-quick-add')) once('pdp_sticky_tap');
      }, true);
      const sizeMsg = new MutationObserver(() => {
        const msg = main.querySelector('.lm-size-msg');
        if (msg && msg.offsetParent !== null && msg.textContent.trim()) { once('pdp_size_needed'); sizeMsg.disconnect(); }
      });
      sizeMsg.observe(main, { childList: true, subtree: true, characterData: true });
      const gallery = main.querySelector('.product-gallery__media-list');
      /* DEV-552 (Developeris B, 2026-09-29): a colour pick scrolls the gallery to that colour's photo by itself, which counted as a
         swipe. Only a scroll that follows the visitor's own touch, pointer or wheel on the gallery (within 1.5 s) and moves it
         more than 40 px from where that touch started counts now. */
      if (gallery) {
        let userAt = 0;
        let userX = 0;
        const mark = () => { userAt = Date.now(); userX = gallery.scrollLeft; };
        const area = gallery.closest('product-gallery') || gallery;
        ['touchstart', 'pointerdown', 'wheel'].forEach((type) => area.addEventListener(type, mark, { passive: true, capture: true }));
        gallery.addEventListener('scroll', () => { if (Date.now() - userAt < 1500 && Math.abs(gallery.scrollLeft - userX) > 40) once('pdp_gallery_swipe'); }, { passive: true });
      }
      const similar = document.querySelector('[id$="__related-products"]');
      if (similar && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((e) => e.isIntersecting)) { once('pdp_similar_seen'); io.disconnect(); }
        });
        io.observe(similar);
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pdp);
    else pdp();
  })();
